
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.139 7.732l.83.83a4 4 0 015.478 5.478l1.143 1.143a16.789 16.789 0 002.413-2.269c.31-.351.565-.667.757-.915a18.752 18.752 0 00-2.073-2.264C16.112 8.285 14.1 6.999 12 6.999c-.979 0-1.943.279-2.861.733zM7.661 6.254L5.413 4.006 4 5.42l14.572 14.572 1.414-1.414-1.969-1.969a19.052 19.052 0 002.488-2.373 21.274 21.274 0 001.7-2.237 16.643 16.643 0 00-1.134-1.567 20.646 20.646 0 00-2.028-2.168C17.359 6.714 14.87 4.999 12 4.999c-1.596 0-3.069.531-4.339 1.255zm6.272 6.272l-2.45-2.45c1.454-.39 2.83 1.025 2.45 2.45zm-5.895-1.067c-.35 2.546 1.945 4.863 4.51 4.511l-4.51-4.51zM3.497 9.762c.389-.441.86-.94 1.401-1.442l1.416 1.415A18.872 18.872 0 004.24 12a18.767 18.767 0 002.073 2.265C7.889 15.714 9.9 16.999 12 16.999c.47 0 .937-.064 1.396-.181l1.584 1.583c-.924.366-1.925.598-2.98.598-2.87 0-5.359-1.715-7.041-3.264-1.194-1.1-2.299-2.357-3.163-3.736.239-.355.475-.711.733-1.053.225-.298.552-.712.968-1.184z"}})])
          )
        }
      }
    